import Axios from 'axios'

// Shared so a second caller joins the request already in flight rather than starting another.
let permissionsRequest = null

export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    permissions: []
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
    },
    getPermissions (state, payload) {
      state.permissions = payload
    }
  },
  actions: {
    login ({ commit }, loginData) {
      // const userCopy = JSON.parse(JSON.stringify(user))
      return new Promise((resolve, reject) => {
        commit('auth_request')
        Axios({ url: `/api/account/login`, data: loginData, method: 'POST' })
          .then(response => {
            const token = response.data.token
            const user = response.data.user
            localStorage.setItem('token', token)
            Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('auth_success', token, user)
            resolve(response)
          })
          .catch(error => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(error.response)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        delete Axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    /**
     * Both the router guard and App.vue ask for this while the app is starting, and the guard has to
     * wait for it - it decides whether to let a route through, and an empty list looks exactly like
     * a user with no rights. Handing back the request already in flight keeps that to one call.
     */
    getPermissions ({ commit }) {
      if (permissionsRequest) {
        return permissionsRequest
      }

      permissionsRequest = new Promise((resolve, reject) => {
        resource.getAllPathAccessRules()
          .then(response => {
            commit('getPermissions', response.data)
            resolve()
          }, error => {
            reject(error.data)
          })
      })
        .finally(() => {
          permissionsRequest = null
        })

      return permissionsRequest
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getUser: state => state.user,
    getToken: state => state.token,
    getPermissions: state => state.permissions
  }
}
